import { Controller } from "@hotwired/stimulus"

// Call modal dédiée phoning :
// - tabs switch (Script / Activités / Infos)
// - selection d'un outcome (highlight, pas submit)
// - bouton Enregistrer final qui submit (form POST + turbo-stream)
export default class extends Controller {
  static targets = ["tab", "panel", "outcomeForm", "outcomeInput", "note", "saveBtn", "saveLabel"]

  connect() {
    this.selectedOutcome = null
    this.updateSaveState()
  }

  switchTab(event) {
    event.preventDefault()
    const key = event.currentTarget.dataset.tab
    this.tabTargets.forEach(t => t.classList.toggle("is-active", t.dataset.tab === key))
    this.panelTargets.forEach(p => p.classList.toggle("is-active", p.dataset.tab === key))
  }

  selectOutcome(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const outcome = btn.dataset.outcome
    if (!outcome) return

    this.selectedOutcome = outcome
    if (this.hasOutcomeInputTarget) this.outcomeInputTarget.value = outcome

    this.element.querySelectorAll("[data-call-modal-target='outcomeBtn']").forEach(b => {
      b.dataset.selected = (b === btn) ? "true" : ""
    })

    this.updateSaveState()
  }

  updateSaveState() {
    if (!this.hasSaveBtnTarget) return
    this.saveBtnTarget.disabled = !this.selectedOutcome
  }

  async submitOutcome(event) {
    event.preventDefault()
    if (!this.selectedOutcome || !this.hasOutcomeFormTarget) return
    if (this.saveBtnTarget.disabled) return

    this.saveBtnTarget.disabled = true
    this.saveBtnTarget.dataset.state = "pending"

    const form = this.outcomeFormTarget
    const formData = new FormData(form)
    const token = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const resp = await fetch(form.action, {
        method: "POST",
        headers: {
          "X-CSRF-Token": token,
          "Accept": "text/vnd.turbo-stream.html, text/html"
        },
        body: formData
      })

      // Toujours rendre les turbo-streams reçus, même en cas d'erreur HTTP.
      // Le serveur peut renvoyer un toast d'erreur (ex: garde "session phoning expirée"
      // qui retourne 422 avec un toast). Sans ça, le user voit juste le bouton rouge
      // sans aucun message. Cas observé chez Martin Firley le 29/04/2026.
      const html = await resp.text()
      if (html.trim().startsWith("<turbo-stream")) {
        const { Turbo } = await import("@hotwired/turbo-rails")
        Turbo.renderStreamMessage(html)
      }

      if (resp.ok) {
        this.saveBtnTarget.dataset.state = "success"
        if (this.hasSaveLabelTarget) this.saveLabelTarget.textContent = "Enregistré"
        if (this.hasNoteTarget) this.noteTarget.value = ""

        setTimeout(() => {
          this.dispatch("logged", { detail: { outcome: this.selectedOutcome }, bubbles: true })
        }, 450)
      } else {
        this.saveBtnTarget.dataset.state = "error"
        this.saveBtnTarget.disabled = false
      }
    } catch (err) {
      console.error("[call-modal] submitOutcome failed", err)
      this.saveBtnTarget.dataset.state = "error"
      this.saveBtnTarget.disabled = false
    }
  }

  focusNote() {
    if (this.hasNoteTarget) this.noteTarget.focus()
  }

  // Listener turbo:submit-end sur le form de disqualification.
  // Le form est en mode standard Turbo (data-turbo-frame="_top") et le controller
  // disqualify_contact renvoie un turbo_stream qui supprime la row + toast + stats.
  // Une fois le submit OK, on auto-advance vers le contact suivant comme un outcome normal.
  onDisqualifySuccess(event) {
    if (!event.detail || !event.detail.success) return
    setTimeout(() => {
      this.dispatch("logged", { detail: { outcome: "disqualified" }, bubbles: true })
    }, 450)
  }
}
